import { Pipe, PipeTransform } from '@angular/core';
import { DocumentTypeEnum } from '../enumerators/document-type.enum';

@Pipe({
  name: 'documentTypeLabel',
  standalone: true,
})
export class DocumentTypeLabelPipe implements PipeTransform {
  transform(value: number): string {
    const labels: Record<number, string> = {
      [DocumentTypeEnum.DNI]: 'DNI',
      [DocumentTypeEnum.Passaport]: 'Pasaporte',
    };

    return labels[value] || 'Desconocido';
  }
}
